import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        margin: 0,
        padding: 0
    },
    stepper_container: {
        width: '80vw',
        "@media (max-width: 800px)": {
            width: '100vw',
        }
    },
    btn_container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'right',
        width: '100%'
    },
    cancel_btn: {
        marginTop: '16px',
        marginLeft: '10px'
    },
    selector:{
        marginTop: '16px',
        marginLeft: '10px'
    }
}));

export {useStyles}